import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SiteLayout from "@/components/site/SiteLayout";
import ArticleCard from "@/components/site/ArticleCard";

const CATEGORY_NAMES = {
  politics: "రాజకీయం",
  district: "జిల్లా వార్తలు",
  agriculture: "వ్యవసాయం",
  crime: "క్రైమ్",
  cinema: "సినిమా/వినోదం",
  special: "ప్రత్యేక కథనాలు",
};

export default function Category() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/articles", { params: { category: slug, limit: 60 } })
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="border-b-4 border-[#2E7D32] pb-4 mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#2E7D32]">విభాగం</div>
          <h1 className="font-heading-te text-4xl md:text-5xl font-black mt-1" data-testid="category-title">
            {CATEGORY_NAMES[slug] || slug}
          </h1>
        </div>
        {loading ? (
          <div className="text-center py-16 font-body-te text-[#4A4A4A]">లోడ్ అవుతోంది...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-16 font-body-te text-[#4A4A4A]" data-testid="category-empty">
            ఈ విభాగంలో ప్రస్తుతం కథనాలు లేవు.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="category-grid">
            {items.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
